import { jsx as t } from "react/jsx-runtime";
import { useToaster as T, toast as C } from "react-hot-toast";
import { useConfig as v } from "../../../../hooks/use-config.js";
import { makeClassesByStyles as R } from "../../../../utils/classes.js";
import { Notification as S } from "../notification/notification.js";
import { NotificationType as i } from "../notification/notification-types.js";
import x from "../../../../assets/f626c6a5.toaster.module.css";
const o = R(x), E = {
  success: i.SUCCESS,
  error: i.ERROR,
  loading: i.WARNING,
  default: i.DEFAULT
}, I = ({ className: r }) => {
  const { toasts: a, handlers: c } = T(), { startPause: l, endPause: m, calculateOffset: f, updateHeight: p } = c, { toastNotificationAlignment: s } = v();
  return /* @__PURE__ */ t(
    "div",
    {
      className: o("Toaster", r, {
        [`--${s}`]: !!s
      }),
      onMouseEnter: l,
      onMouseLeave: m,
      children: /* @__PURE__ */ t(
        "div",
        {
          className: o("container", {
            [`--${s}`]: !!s
          }),
          children: a.map((e) => {
            const { position: d, style: u } = e, g = f(e, {
              reverseOrder: !1,
              gutter: 8
            }), y = (n) => {
              if (n && !e.height) {
                const N = n.getBoundingClientRect().height;
                p(e.id, N);
              }
            }, h = typeof e.message == "function" ? e.message(e) : e.message;
            return /* @__PURE__ */ t(
              S,
              {
                className: o("toast", `--${d}`),
                ref: y,
                type: E[e.type],
                onClose: () => C.dismiss(e.id),
                isDismissible: e.duration !== 1 / 0,
                style: {
                  position: "absolute",
                  transition: "all 0.5s ease-out",
                  opacity: e.visible ? 1 : 0,
                  transform: `translateY(${g}px)`,
                  ...u
                },
                ...e.ariaProps,
                children: h
              },
              e.id
            );
          })
        }
      )
    }
  );
};
export {
  I as Toaster
};
